<div class="ui basic segment">
    <app-header
        title="{{
            {
                key: 'payroll.records.payrollAndDateRange',
                params: {
                    startDate: payroll.startDate | appDate: 'MMM d',
                    endDate: payroll.endDate | appDate: 'MMM d',
                },
            } | appTranslate
        }}"
        [badgeOptions]="{ label: 'payroll.records.paid', type: 'success' }"
        [back]="true"
        [backRoute]="['/payroll/records/payrolls']"
    >
        <div class="buttons">
            <a href="https://support.humi.ca/" target="_blank">{{
                'payroll.records.haveAquestionAboutPayroll' | translate
            }}</a>
        </div>
    </app-header>
    <div class="app-grid">
        <ui-card class="columns-8 medium-columns-12 large-columns-12">
            <div class="app-grid">
                <div class="flex middle columns-6 large-columns-12 margin-bottom-4 margin-top-2">
                    <div>
                        <h4>{{ 'payroll.records.payPeriod' | translate }}</h4>
                        {{ payroll.startDate | appDate }} - {{ payroll.endDate | appDate }}
                        <h4>{{ 'payroll.records.payDate' | translate }}</h4>
                        {{ payroll.chequeDate | appDate }}
                        <h4>{{ 'payroll.run.payrollTypeHeader' | translate }}</h4>
                        {{
                            'payroll.run.payrollType'
                                | translate
                                    : {
                                          type: payrollType,
                                          period: payroll.periodNo,
                                          totalPeriods: payroll.totalPeriods,
                                      }
                        }}
                        <h4>{{ 'payroll.records.totalPayrollAmount' | translate }}</h4>
                        {{ payroll.liability | i18nNum: '$' }}
                        <ng-container *ngIf="showQhsfRate">
                            <h4>{{ 'payroll.run.qhsfRate' | translate }}</h4>
                            {{ payroll.eptSummariesQc[0].taxRate | i18nNum }}
                        </ng-container>
                    </div>
                </div>
                <div class="columns-6 large-columns-12">
                    <img src="/assets/illustrations/chair-money-plant.png" style="max-width: 100%" />
                </div>
                <div class="columns-12">
                    <ui-button
                        type="outline"
                        [externalLink]="true"
                        url="/payroll/records/payrolls/{{ payroll.id }}/hours"
                        class="margin-right-1"
                        >{{ 'payroll.records.viewPayrollHours' | translate
                        }}<mat-icon class="margin-left-1" svgIcon="openInNew"></mat-icon
                    ></ui-button>
                    <ui-button
                        type="outline"
                        [externalLink]="true"
                        url="/payroll/records/payrolls/{{ payroll.id }}/details"
                        class="margin-right-1"
                        >{{ 'payroll.records.viewPayrollDetails' | translate
                        }}<mat-icon class="margin-left-1" svgIcon="openInNew"></mat-icon
                    ></ui-button>
                    <ui-button type="outline" [externalLink]="true" url="{{ payrollRegisterUrl }}"
                        >{{ 'payroll.records.viewPayrollRegisterReport' | translate
                        }}<mat-icon class="margin-left-1" svgIcon="openInNew"></mat-icon
                    ></ui-button>
                </div>
            </div>
        </ui-card>
    </div>

    <ui-card *ngIf="payroll.eptSummariesNonQc">
        <app-segment-header [title]="'payroll.run.otherRemittancesPay.otherRemittancesOwing'" />
        <app-other-remittances-pay [eptSummaries]="payroll.eptSummariesNonQc" [useBanner]="true" />
    </ui-card>

    <ui-card *ngIf="shouldShowXeroCard">
        <div class="flex width-full">
            <div class="flex width-full align-items-start">
                <img class="margin-right-3" src="assets/logos/xero-fill.png" alt="Xero" />
                <h2 class="margin-y-auto margin-right-2">
                    {{ xeroCompanyName ?? ('payroll.records.xeroIntegration' | translate) }}
                </h2>
                <ui-badge class="margin-y-auto" [type]="xeroStatus">{{ xeroStatusMessage | translate }}</ui-badge>
            </div>
        </div>
    </ui-card>

    <app-transactions-table [payroll]="payroll"></app-transactions-table>
</div>
